<!-- <div *ngIf="searchResultsViewFlag" style="width:auto;">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="goToHome()">Home &nbsp;</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="switchDeckView()">KMS Portal &nbsp;</li>
      <li class="breadcrumb-item active" aria-current="page" (click)="onSelectVertical()">{{extractedString1}}</li>
    </ol>
  </nav>
</div>
<div *ngIf="!searchResultsViewFlag" style="width:auto;">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" (click)="goToHome()">Home &nbsp;</li>
      <li class="breadcrumb-item active" (click)="switchDeckView()">KMS Portal &nbsp;</li>
    </ol>
  </nav>
</div> -->

<ng-container class="container-fluid p-0" *ngIf="!searchResultsViewFlag;else resultsView">
  <div class="col-12 p-0">
    <div class="row m-0" style="padding-top: 30px;">
      <div class="col-12 col-lg-10 p-0">
        <div class="category-carousel">
          <div class="row m-0 px-5">
            <div class="col-auto mr-auto pl-0 page_title pt-2  " id="carousel">
              Explore by Category
            </div>
          </div>
          <!--- carousal section--->
          <div class="row m-0 d-flex px-5 justify-content-around mt-2 pb-2 ">
            <ngx-slick-carousel class="carousel w-100 " #slickModal="slick-carousel" [config]="slideConfig"
              (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
              (beforeChange)="beforeChange($event)">
              <div ngxSlickItem class="p-2 slide" *ngFor="let category of categoryList">
                <div class="carousel-card d-flex cursorPointer " (click)="fetchResultsByCategory(category.data)">
                  <div class="card-left">
                    <div class="icon-content d-flex">
                      <div class="d-flex justify-content-center card_icon"
                        [ngStyle]="{'background-color':category.iconBGColor}">
                        <img class="align-self-center" width="32px" src="assets/images/{{category.iconUrl}}" />
                      </div>
                      <div class="subtitle_card align-self-center " style="color:#183B8C">
                        {{category.name}}
                      </div>
                    </div>
                    <div class="bodyCopy category-desc">
                      {{category.description}}
                    </div>
                  </div>
                  <div class="card-right  my-auto">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </ngx-slick-carousel>
          </div>
        </div>
        <div class="speciality-section">
          <div class="row m-0 px-5">
            <div class="col-12 pl-2 page_title pt-2" id="speciality" *ngIf="specialityList">
              Explore Case Studies by Speciality
            </div>
          </div>
          <div class="row m-0 domain_s px-5">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 p-2 mt-2" *ngFor="let option of displayedOptions">
              <div class="card specialityCard" [style.backgroundImage]="'url(' + option.image + ')'"
                [routerLink]="['/Home/KMSPortal', option.name]" *ngIf="option.count > 0">
                <div class="speciality-card-name">
                  {{ option.name }}<span class="speciality-count"
                    [ngClass]="{'speciality-count-single': option.count >= 0 && option.count <= 9, 'speciality-count-double': option.count >= 10}">
                    {{ option.count }}
                  </span>
                </div>
                <div class="speciality-card-chevron-right">
                  <i class="fas fa-chevron-right sc-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="row m-0 px-5 viewerButton">
            <ng-container *ngIf="!verticalOptionsFlag && specialityList"> 
              <div class="col-12 d-flex justify-content-end p-1 pt-2 mb-4 pb-4">
                <button class="btn btn-primary category_btn border-0" id="" data-toggle="collapse"
                 (click)="showSpecialityOptions()" data-target="#collapseSpeciality" type="button" *ngIf="this.Options?.length > 8">
                  <i class="fas fa-angle-double-down"></i><span class="align-self-center">View More </span>
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="verticalOptionsFlag && specialityList">
              <div class="col-12 d-flex justify-content-end p-1 pt-2 mb-4 pb-4">
                <button class="btn btn-primary category_btn border-0" id="" data-toggle="collapse"
                  (click)="showSpecialityOptions()" data-target="#collapseSpeciality" type="button">
                  <i class="fas fa-angle-double-up"></i><span class="align-self-center">View Less</span>
                </button>
              </div>
            </ng-container>
          </div>
        </div>


      </div>

      <div class="d-none d-lg-block col-md-2" style="background-color: #F7F7F7;">
        <div class="row m-0">
          <div class="col-12 d-flex justify-content-center mt-3 p-0">
            <span class="mr-auto subtitle_card1 align-self-center">Most Downloads</span><span><img
                class="align-self-center pl-1" src="assets/images/download_icon.svg" width="18px"></span>
          </div>
          <div class="col-12 p-0">
            <div class="d-flex bodyCopy pt-1 justify-content-center"
              *ngFor="let mostDownloadedProject of mostDownloadedProjects">
              <span
                class="mr-auto">{{mostDownloadedProject.projectName}}</span><span>{{mostDownloadedProject.fileDownloadCount}}</span>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center mt-3 p-0">
            <span class="mr-auto subtitle_card1 align-self-center">Most Viewed</span><span><img
                class="align-self-center pl-1" src="assets/images/viewed_icon.svg" width="20px"></span>
          </div>
          <div class="col-12 p-0">
            <div class="d-flex bodyCopy pt-1 justify-content-center"
              *ngFor="let mostViewedProject of mostViewedProjects">
              <span
                class="mr-auto text-truncate">{{mostViewedProject.projectName}}</span><span>{{mostViewedProject.fileViewCount}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-container>



<ng-template #resultsView>



  <div class="container-fluid cards_box p-0">
    <!---card to be repeated--->
    <ng-container *ngIf="projectsView === 'card'; else tableView">
      <ng-container *ngIf="groupedSearchResults.length > 0; else ungrouped">
        <ng-container *ngFor="let groupedResults of groupedSearchResults ">
          <div class="mt-2 mb-4">
            <div class="col-12">
              <h5>{{groupedResults.groupBy}}</h5>
            </div>
            <div class="row-dupe">
              <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2"
                *ngFor="let attachment of groupedResults.attachments">
                <div class="card">
                  <div *ngIf="attachment.restrictedContent" class="resticted-project">Restricted</div>
                  <div style="position: absolute;top: 10; z-index:1; width: 100%">
                    <div class="d-flex justify-content-end">
                      <i *ngIf="!attachment.restrictedContent"></i>
                      <div class="mr-2" style="position: relative; width: 20px">
                        <div class="container_chk1" *ngIf="attachment.checked">
                          <input type="checkbox" [checked]="attachment.checked" (click)="selectAttachment(attachment)">
                          <span class="checkmark1"></span>
                        </div>
                        <div class="container_chk1" *ngIf="!attachment.checked">
                          <input type="checkbox" [checked]="attachment.checked" (click)="selectAttachment(attachment)">
                          <span class="checkmark1 checkmark2"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" row m-0 border-bottom">
                    <div class="col-6 p-0 locationspace">
                      <div class="img_spacing  d-flex"><img class="mx-auto d-block img-obj-contain" style="width:50%"
                          [src]="attachment.logo" />
                      </div>
                      <div class="content_spacing" style="height:16px;overflow:hidden"><span
                          class="mx-auto d-block heading_3 text-truncate" matTooltip="{{attachment.client}}"
                          matTooltipPosition="right">{{attachment.client}} </span>
                      </div>
                      <div class="content_spacing d-inline-flex text-truncate "><span><i
                            class="fas fa-map-marker-alt mr-2"></i></span><span class="d-block heading_3"
                          style="font-size: 0.750em;font-weight: 400;line-height: 14px;color: #939393; margin-top:6px"
                          matTooltip="{{attachment.geography}}"
                          matTooltipPosition="right">{{attachment.geography}}</span>
                      </div>
                      <div class="content_spacing" *ngIf="attachment.score>=0"><span style="margin-left:-2px"><i
                            class="fas fa-star mr-2"></i></span><span class="secondaryInfo">{{attachment.score}}</span>
                      </div>
                      <div class="content_spacing"><span style="margin-left:-2px">
                        </span><span class="organizationName">{{attachment.deliveryOrganization}}</span>
                      </div>
                    </div>
                    <div class="col-6" style="position: relative">
                      <img class="mx-auto d-block locationimg" width="100%" height="100%"
                        src="{{attachment.geographyURL}}" />
                    </div>
                  </div>
                  <div class="row m-0 ">
                    <div class="col-xl-10 col-md-10 p-0 ">
                      <div class="row">
                        <div class="col-12">
                          <div class="content_spacing1 mt-1" style="width: 100%">
                            <div><i class="fas fa-briefcase mr-2"></i></div>
                            <div class="secondaryInfo pt-1">Project Name </div>
                          </div>
                          <div class="content_spacing1 w-100">
                            <div class="heading_2 pl-4 text-truncate" matTooltip="{{attachment.projectName}}"
                              matTooltipPosition="right">{{attachment.projectName}}</div>
                          </div>
                        </div>
                        <div class="col-6 col-md-6 ">
                          <div class="content_spacing1">
                            <div><i class="far fa-user mr-2 mr-2"></i></div>
                            <div class="secondaryInfo pt-1">Project Manager </div>
                          </div>
                          <div class="content_spacing1 w-100">
                            <div class="heading_3 pl-4 text-truncate" matTooltip="{{attachment.projectManager}}"
                              matTooltipPosition="right">
                              {{attachment.projectManager}}</div>
                          </div>
                        </div>
                        <div class="col-6 col-md-6 col-lg-6 pl-0 ">
                          <div class="content_spacing1 ">
                            <div><i class="far fa-user mr-2 mr-2"></i></div>
                            <div class="secondaryInfo pt-1">Sales Contact </div>
                          </div>
                          <div class="content_spacing1 w-100">
                            <div class="heading_3 pl-4 text-truncate" matTooltip="{{attachment.bdContact}}"
                              matTooltipPosition="right">
                              {{attachment.bdContact}}</div>
                          </div>
                        </div>
                        <div class="col-12 tags">
                          <div class="content_spacing1 mt-2  border-top" style="width: 100%">
                            <div class="mt-2"><i class="fas fa-tag mr-2  "></i></div>
                            <div class="secondaryInfo pt-1 mt-2  ">Related Tags</div>
                          </div>
                          <div class="content_spacing1 chide ">
                            <div class="bodyCopy pl-4 " style="word-break:break-word">{{attachment.tags}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-2 col-xl-2 col-md-auto p-0 iconbdr1" style="position: relative;  ">
                      <div class="d-flex iconspace p-0">
                        <div class="viewContent swidth iconbdr">
                          <div class="text-center swidth  view-type">
                            <div class="type-text">
                              <div class="border-bottom-grey pb-mb-3 view-options" (click)="viewFile(attachment,'tcs')">
                                Technology Case Study
                              </div>
                              <div class="view-options" (click)="viewFile(attachment,'bcs')">Business Case Study</div>
                            </div>
                            <div class="view-count" style="margin-top:5px"><i class="fas fa-eye"></i>
                            </div>
                            <div class=" view-count"><span
                                class="secondaryInfo d-inline-block pb-0">{{attachment.viewCount}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="iconbdr text-center swidth" align="center" *ngIf="!restrictDownloadAndMail"
                          (click)="sendMail(attachment,'single')">
                          <i class="fas fa-envelope py-3"></i>
                        </div>
                        <div class="downloadContent swidth iconbdr"
                          *ngIf="!restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
                          <div class=" text-center swidth">
                            <div class="type-text">
                              <div class="border-bottom-grey pb-mb-3 view-options"
                                (click)="downloadFile(attachment,'tcs')">
                                Technology Case Study
                              </div>
                              <div class="view-options" (click)="downloadFile(attachment,'bcs')">Business Case Study
                              </div>
                            </div>
                            <div class="cdownload download-count" style="margin-top:5px"><i
                                class="fas fa-download "></i>
                            </div>
                          </div>
                        </div>
                        <div class="iconbdr text-center swidth" (click)="editProject(attachment.id)" align="center">
                          <i class="fas fa-edit  py-3" style="margin-left:3px"
                            *ngIf="(!(checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization == organizationName) || checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') || checkRole('CaseStudies.ContentManager') "></i>
                        </div>
                        <div class="text-center swidth" (click)="deleteFile(attachment.id)" align="center"><i
                            class="far fa-trash-alt py-3"
                            *ngIf="!((checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization == organizationName)|| checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') || checkRole('CaseStudies.ContentManager') "></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #ungrouped>

        <div class="d-flex " style="margin-top:10px">
          <div class="page_title align-self-center" *ngIf="searchResults != 0 ">Dashboard <span *ngIf="verticalOption">-
              {{verticalOption}}</span>
          </div>
        </div>

        <div class="row m-0  margin-bottom-to-footer">

          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-0 " *ngFor="let attachment of searchResults ">

            <div class="card">
              <div *ngIf="attachment.restrictedContent" class="resticted-project">Restricted</div>

              <div style="position: absolute;top: 10; z-index:1; width: 100%">
                <div class="d-flex justify-content-end">
                  <i *ngIf="!attachment.restrictedContent"></i>
                  <div class="mr-2" style="position: relative; width: 20px">
                    <div class="container_chk1" *ngIf="attachment.checked">
                      <input type="checkbox" [checked]="attachment.checked" (click)="selectAttachment(attachment)">
                      <span class="checkmark1"></span>
                    </div>
                    <div class="container_chk1" *ngIf="!attachment.checked">
                      <input type="checkbox" [checked]="attachment.checked" (click)="selectAttachment(attachment)">
                      <span class="checkmark1 checkmark2"></span>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row m-0 border-bottom">
                <div class="col-6 p-0 locationspace">
                  <div class="img_spacing d-flex">
                    <img class="mx-auto d-block img-obj-contain" style="width:50%" src="{{attachment.logo}}" />
                  </div>
                  <div class="content_spacing" style="height:16px;overflow:hidden"><span
                      class="mx-auto d-block heading_3 text-truncate" matTooltip="{{attachment.client}}"
                      matTooltipPosition="right">{{attachment.client}} </span>
                  </div>
                  <div class="content_spacing d-inline-flex  "><span><i
                        class="fas fa-map-marker-alt mr-2"></i></span><span class="d-block heading_3 text-truncate"
                      style="font-size: 0.750em;font-weight: 400;line-height: 14px;color: #939393; margin-top:6px"
                      matTooltip="{{attachment.geography}}" matTooltipPosition="right">{{attachment.geography}}</span>
                  </div>
                  <div class="content_spacing" *ngIf="attachment.score"><span style="margin-left:-2px"><i
                        class="fas fa-star mr-2"></i></span><span class="secondaryInfo ">{{attachment.score}} </span>
                  </div>
                  <div class="content_spacing"><span style="margin-left:-2px">
                    </span><span class="organizationName">{{attachment.deliveryOrganization}}</span>
                  </div>
                </div>
                <div class="col-6" style="position: relative">
                  <img class="mx-auto d-block locationimg" width="100%" height="100%"
                    src="{{attachment.geographyURL}}" />
                </div>
              </div>
              <div class="row m-0 ">
                <div class="col-xl-10 col-md-10 p-0  ">
                  <div class="row m-0">
                    <div class="col-12">
                      <div class="content_spacing1 mt-1" style="width: 100%">
                        <div><i class="fas fa-briefcase mr-2"></i></div>
                        <div class="secondaryInfo pt-1">Project Name </div>
                      </div>
                      <div class="content_spacing1 w-100 ">
                        <div class="heading_2 pl-4 text-truncate" matTooltip="{{attachment.projectName}}"
                          matTooltipPosition="right">
                          {{attachment.projectName}}</div>
                      </div>
                    </div>


                    <div class="col-6 col-md-6 ">
                      <div class="content_spacing1">
                        <div><i class="far fa-user mr-2 mr-2"></i></div>
                        <div class="secondaryInfo pt-1">Project Manager </div>
                      </div>
                      <div class="content_spacing1 w-100">
                        <div class="heading_3 pl-4 text-truncate" matTooltip="{{attachment.projectManager}}"
                          matTooltipPosition="right">
                          {{attachment.projectManager}}</div>
                      </div>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 pl-0">
                      <div class="content_spacing1 ">
                        <div><i class="far fa-user mr-2 mr-2"></i></div>
                        <div class="secondaryInfo pt-1">Sales Contact </div>
                      </div>
                      <div class="content_spacing1 w-100 ">
                        <div class="heading_3 pl-4 text-truncate" matTooltip="{{attachment.bdContact}}"
                          matTooltipPosition="right">
                          {{attachment.bdContact}}

                        </div>
                      </div>
                    </div>
                    <div class="col-12 tags">
                      <div class="content_spacing1 mt-2  border-top" style="width: 100%">
                        <div class="mt-2"><i class="fas fa-tag mr-2  "></i></div>
                        <div class="secondaryInfo pt-1 mt-2  ">Related Tags</div>
                      </div>
                      <div class="content_spacing1 chide ">
                        <div class="bodyCopy pl-4 " style="word-break: break-word">{{attachment.tags}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2 col-xl-2 col-md-auto p-0 iconbdr1" style="position: relative;">
                  <div class="d-flex iconspace p-0">
                    <div class="viewContent swidth iconbdr">
                      <div class="text-center swidth view-type">

                        <!-- Tooltip when business case study is present   -->
                        <div class="type-text " *ngIf="attachment.businessCaseStudyFlag">
                          <div class="border-bottom-grey pb-mb-3 view-options" (click)="viewFile(attachment,'tcs')">
                            Technology
                            Case Study
                          </div>
                          <div class="view-options" (click)="viewFile(attachment,'bcs')">Business Case Study</div>
                        </div>

                        <!-- Regular Eye icon for Technology case study-->
                        <div class="view-count" style="margin-top:5px">
                          <i *ngIf="attachment.businessCaseStudyFlag" class="fas fa-eye"></i>
                          <i *ngIf="!attachment.businessCaseStudyFlag" class="fas fa-eye"
                            (click)="viewFile(attachment,'tcs')"></i>
                        </div>
                        <div class=" view-count"><span
                            class="secondaryInfo d-inline-block pb-0">{{attachment.viewCount}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="iconbdr text-center swidth" align="center" *ngIf="!restrictDownloadAndMail"
                      (click)="sendMail(attachment,'single')">
                      <i class="fas fa-envelope py-3"></i>
                    </div>
                    <div class="downloadContent swidth iconbdr"
                      *ngIf="!restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
                      <div class=" text-center swidth">
                        <!-- Tooltip when business case study is present   -->
                        <div class="type-text " *ngIf="attachment.businessCaseStudyFlag">
                          <div class="border-bottom-grey pb-mb-3 view-options" (click)="downloadFile(attachment,'tcs')">
                            Technology
                            Case Study
                          </div>
                          <div class="view-options" (click)="downloadFile(attachment,'bcs')">Business Case Study</div>
                        </div>
                        <div class="cdownload download-count" style="margin-top:5px"
                          *ngIf="!(checkRole('CaseStudies.Viewer'))">
                          <i class="fas fa-download " *ngIf="attachment.businessCaseStudyFlag"></i>
                          <i class="fas fa-download " (click)="downloadFile(attachment,'tcs')"
                            *ngIf="!attachment.businessCaseStudyFlag"></i>
                        </div>
                      </div>
                    </div>
                    <div class="iconbdr text-center swidth"
                      *ngIf="(!(checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization == organizationName) || checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') || checkRole('CaseStudies.ContentManager')"
                      (click)="editProject(attachment.id)" align="center"><i class="fas fa-edit  py-3"
                        style="margin-left:3px"></i></div>
                    <div class="text-center swidth"
                      *ngIf="(!(checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization == organizationName)|| checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') ||  checkRole('CaseStudies.ContentManager') "
                      (click)="deleteFile(attachment.id)" align="center"><i
                        class="far fa-trash-alt px-bottom-icons  py-3"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- Table View of corresponding cards-->
    <ng-template #tableView>
      <div class="modal-container">
        <div class="row m-0">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 mt-0 ">
            <div class="">
              <!---Title-->
              <div class="col-12 alignment">
                <div class="page_title align-self-center" (click)="onSelectVertical(vertical.name)">
                  {{extractedString1 }} &nbsp;
                </div>
                <div class="btn-group add_button">
                  <button type="button" data-reference="parent" *ngIf="!kmsViewer"
                    class="btn btn-secondary w-100 add-btn" (click)="onChangeProjectType('Case Studies',verticalOption)"><i
                      class="fas fa-plus"></i>Add Case Study </button>
                </div>
              </div>

              <!---row loop-->
              <ng-container *ngIf="groupSearchFlag === true ; else ungroupedTableView">
                <div *ngFor="let groupSearchResult of groupedSearchResults">
                  <div class="col-12 mb-0 d-flex" style="justify-content: center;margin-top:10px;margin-bottom:5px">
                    <h6 class="heading_1 mb-0">{{groupSearchResult.groupBy}}</h6>
                  </div>
                  <div class="row p-3 m-0 border-bottom" *ngFor="let attachment of groupSearchResult.attachments">
                    <div class="col-xs-9 col d-flex p-0">

                      <div class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                        style="display: flex;align-items: center">

                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="{{attachment.id}}"
                            [checked]="attachment.checked" (click)="selectAttachment(attachment)">
                          <label class="custom-control-label" style="cursor:pointer" for="{{attachment.id}}"></label>
                        </div>

                      </div>
                      <div class="col-7 ">
                        <div class="row m-0">
                          <div class="col-10 col-md-3 col-lg-3 text-truncate">
                            <div class="pr-2">
                              <div><span class="secondaryInfo">Project Name </span></div>
                              <div class=" text-truncate" matTooltip="{{attachment.projectName}}"
                                matTooltipPosition="left">
                                <span class="heading_3 ">{{attachment.projectName}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 col-md-3 col-lg-3 text-truncate">
                            <div class="pr-2">
                              <div><span class="secondaryInfo">Project Manager</span></div>
                              <div class="text-truncate"><span class="heading_3">{{attachment.projectManager}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 col-md-3 col-lg-3 text-truncate ">
                            <div class="pr-2">
                              <div><span class="secondaryInfo">Sales Contact</span></div>
                              <div class="text-truncate"><span class="heading_3">{{attachment.bdContact}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 col-md-3 col-lg-3  text-truncate">
                            <div class="pr-2">
                              <div><span class="secondaryInfo">Location</span></div>
                              <div class="text-truncate">
                                <span class="heading_3" matTooltip="{{attachment.geography}}"
                                  matTooltipPosition="left">{{attachment.geography}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-3 col-auto d-flex p-0 border-left">
                        <div class="buttons_column align-self-center  p-0">
                          <button type="button" class="btn btn-custom_primary mr-1 ml-1" id="inv_setup_save"
                            data-toggle="modal" data-target="" data-backdrop="static" data-keyboard="false"
                            (click)="viewFile(attachment)"><i class="fas fa-eye text-warning"></i> </button>
                          <button type="button" *ngIf="!restrictDownloadAndMail" class="btn btn-custom_primary  mx-1"
                            id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false" (click)="sendMail(attachment,'single')"><i
                              class="fas fa-envelope"></i>
                          </button>
                          <button type="button" *ngIf="!restrictDownloadAndMail" class="btn btn-custom_primary mx-1 "
                            id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false"><i class="fas fa-download "></i> </button>
                          <div class="downloadContent swidth iconbdr"
                            *ngIf="!restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
                            <div class=" text-center swidth">
                              <!-- Tooltip when business case study is present   -->

                              <div class="type-text " *ngIf="attachment.businessCaseStudyFlag">
                                <div class="border-bottom-grey pb-mb-3 view-options"
                                  (click)="downloadFile(attachment,'tcs')">
                                  Technology
                                  Case Study
                                </div>
                                <div class="view-options" (click)="downloadFile(attachment,'bcs')">Business Case Study
                                </div>
                              </div>
                              <div class="cdownload download-count" style="margin-top:5px">
                                <i class="fas fa-download " *ngIf="attachment.businessCaseStudyFlag"></i>
                                <i class="fas fa-download " (click)="downloadFile(attachment,'tcs')"
                                  *ngIf="!attachment.businessCaseStudyFlag"></i>

                              </div>

                            </div>
                          </div>
                          <button type="button" class="btn btn-custom_primary mx-1 "
                            *ngIf="(!(checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization === organizationName)|| checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') ||  checkRole('CaseStudies.ContentManager') "
                            (click)="editProject(attachment.id)" id="inv_setup_save" data-toggle="modal" data-target=""
                            data-backdrop="static" data-keyboard="false"><i class="fas fa-edit text-success "
                              style="margin-left:3px"></i></button>
                          <button type="button" class="btn btn-custom_primary mx-1 "
                            *ngIf="(!(checkRole('CaseStudies.Viewer')) && attachment.deliveryOrganization === organizationName)|| checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') ||  checkRole('CaseStudies.ContentManager') "
                            (click)="deleteFile(attachment.id)" id="inv_setup_save" data-toggle="modal" data-target=""
                            data-backdrop="static" data-keyboard="false"><i
                              class="far fa-trash-alt px-bottom-icons  text-danger"></i></button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </ng-container>
              <ng-template #ungroupedTableView>
                <div class="row mx-0 carporate-deck-cards" *ngIf="searchResults && searchResults.length > 0">
                  <div class="result col-xl-4 col-lg-4 col-md-6 card-b-space" *ngFor="let result of searchResults">


                    <div class="card d-flex justify-content-end m-0">
                      <div *ngIf="result.restrictedContent" class="resticted-project">Restricted</div>
                      <div class="d-flex flex-xl-row flex-column">
                        <div
                          class="card-left d-flex flex-xl-column flex-sm-row flex-column justify-content-xl-start justify-content-around borderRight">
                          <img width="120" height="75" src="{{ result.logo ? result.logo : (result.logoImage ? 'data:image/jpg;base64,' + result.logoImage : '') }}">


                          <div class="pl-2 ml-1">

                            <div class="project-name mb-2" [ngbTooltip]="result.projectName" placement="top"
                              triggers="manual" #tooltip="ngbTooltip" (mouseleave)="tooltip.close()"
                              (mouseover)="tooltip.open()">
                              {{result.projectName}}
                            </div>

                            <div class=" mb-2">
                              <div class="date-labels"> Region</div>
                              <div class="date-value">{{result.region ? result.region : 'N/A'}} </div>
                            </div>
                            <div class="mb-2">
                              <div class="date-labels">Contact Person</div>
                              <div class="date-value">{{result.bdContact ? result.bdContact : 'N/A'}} </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-right">
                          <div class="d-flex card-inner">
                            <div class="icon-width-alignment">
                              <img height="16" width="16" src="../../../assets/images/info.svg">
                            </div>
                            <div class="pl-2">
                              <div class="date-labels">Location</div>
                              <div class="date-value desc-wrap" tooltipClass="tooltip-wrap"
                                [ngbTooltip]="result.geography" placement="top bottom" triggers="manual"
                                (click)="projectDescription.open()" #projectDescription="ngbTooltip"
                                (mouseleave)="projectDescription.close()" (mouseover)="projectDescription.open()">
                                {{result.geography ? result.geography : 'N/A'}}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex card-inner mb-3">
                            <div class="icon-width-alignment">
                              <img height="16" width="16" src="../../../assets/images/purpose_icon.svg">
                            </div>
                            <div class=" pl-2">
                              <div class="date-labels">Project Manager</div>
                              <div class="date-value purpose-wrap" tooltipClass="tooltip-wrap"
                                [ngbTooltip]="result.projectManager" placement="top bottom" triggers="manual"
                                (click)="projectPurpose.open()" #projectPurpose="ngbTooltip"
                                (mouseleave)="projectPurpose.close()" (mouseover)="projectPurpose.open()">

                                {{result.projectManager ? result.projectManager : 'N/A'}}
                              </div>
                            </div>
                          </div>
                          <div class="d-flex card-inner">
                            <div class="icon-width-alignment">
                              <img height="16" width="16" src="../../../assets/images/tags.svg">
                            </div>
                            <div class="pl-2">
                              <div class="date-labels">Related&nbsp;Tags</div>
                              <div class="date-value related-wrap" [ngbTooltip]="result.tags"
                                tooltipClass="tooltip-wrap" placement="top bottom" triggers="manual"
                                (click)="tooltipTags.open()" #tooltipTags="ngbTooltip"
                                (mouseleave)="tooltipTags.close()" (mouseover)="tooltipTags.open()">
                                {{result.tags ? result.tags : 'N/A'}}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end card-footer py-0 pr-0">
                        <div>
                          <i class="fas fa-eye px-bottom-icons hideView" *ngIf="result.restrictedContent && checkRole('CaseStudies.Viewer')" (click)="openInfoDialog(result,'View')"
                            id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false"></i>
                          <i class="fas fa-eye px-bottom-icons" *ngIf="!(checkRole('CaseStudies.Viewer')) || (!result.restrictedContent && checkRole('CaseStudies.Viewer'))" (click)="openInfoDialog(result,'View')"
                            id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false"></i>

                          <i class="fas fa-download px-bottom-icons"
                            *ngIf="!restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))"
                            (click)="openInfoDialog(result,'Download')" id="inv_setup_save" data-toggle="modal"
                            data-target="" data-backdrop="static" data-keyboard="false"></i>
                          <ng-template let-data #myInfoDialog>
                            <h1 mat-dialog-title class="popup-title w-100">
                              <div *ngIf="data.Action == 'Download'">Download {{data.Result.projectName}} Case Studies
                              </div>
                              <div *ngIf="data.Action == 'View'">View {{data.Result.projectName}} Case Studies</div>
                            </h1>
                            <div class="col">
                              <div class=" popcontent1 row" *ngIf="data.Result.attachmentName">
                                <div style="padding-left: 15px;">
                                  <div class="row m-0">
                                    <div>
                                      <h5 class="view-data" matTooltip="{{ data.Result.attachmentName }}">
                                        {{ data.Result.attachmentName }}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="data.Action == 'Download'" style="margin-left: auto;">
                                  <i class="fas fa-download px-bottom-icons"
                                    (click)="downloadFile(data.Result,'tcs')"></i>
                                </div>
                                <div *ngIf="data.Action == 'View'" style="margin-left: auto;">
                                  <i class="fas fa-eye px-bottom-icons " (click)="viewFile(data.Result,'tcs')"></i>
                                </div>
                                <br>
                              </div>
                              <br>
                              <div class="popcontent2 row" *ngIf="data.Result.bussinessCaseFileName">
                                <div style="padding-left: 15px;">
                                  <div class="row m-0">
                                    <div>
                                      <h5 class="view-data" matTooltip="{{ data.Result.bussinessCaseFileName }}">
                                        {{ data.Result.bussinessCaseFileName }} </h5>
                                    </div>
                                  </div>
                                </div>
                                <div *ngIf="data.Action == 'Download'" style="margin-left: auto;">
                                  <i class="fas fa-download px-bottom-icons"
                                    (click)="downloadFile(data.Result,'bcs')"></i>
                                </div>
                                <div *ngIf="data.Action == 'View'" style="margin-left: auto;">
                                  <i class="fas fa-eye px-bottom-icons" (click)="viewFile(data.Result,'bcs')"></i>
                                </div>
                                <br>
                              </div>

                            </div>
                            <div mat-dialog-actions class="popup-buttons justify-content-end">
                              <button mat-dialog-close style="border: 1px solid #183B8C;"
                                class="btn popup-cancelbutton">
                                Close
                              </button>
                            </div>
                          </ng-template>

                          <i class="fas fa-pencil-alt px-bottom-icons  pt-2" *ngIf="(!(checkRole('CaseStudies.Viewer')) && result.deliveryOrganization === organizationName) || checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') ||  checkRole('CaseStudies.ContentManager')
                           " id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false" (click)="editProject(result.id,extractedString1)"></i>
                          <i class="fas fa-trash px-bottom-icons py-3"
                            *ngIf="(!(checkRole('CaseStudies.Viewer')) 
                          && result.deliveryOrganization == organizationName)|| checkRole('CaseStudies.SuperAdmin') || checkRole('CaseStudies.Admin') || checkRole('CaseStudies.ContentManager') "
                            id="inv_setup_save" data-toggle="modal" data-target="" data-backdrop="static"
                            data-keyboard="false" (click)="deleteFile(result.id)"></i>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

  </div>

  <div #actions class="actions">
    <div *ngIf="restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
      <i class="fas fa-envelope whiteFont" (click)="sendMail(mailMultipleAttachments,'')"></i>
    </div>
    <hr class="my-2 break" />
    <div *ngIf="restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
      <i class="fas fa-download whiteFont cursorPointer" (click)="downloadPPts()"></i>
    </div>
    <hr class="my-2 break" />
    <div *ngIf="restrictDownloadAndMail && !(checkRole('CaseStudies.Viewer'))">
      <i class="fas fa-trash-alt  whiteFont cursorPointer" (click)="deleteItems()" id="trashIcon"></i>
    </div>
  </div>

  <div *ngIf="searchResults == 0 && !loading">
    <mat-card class="mt-3">
      <mat-card-content class="text-center custom_subtiles1 fs-16">No Records Found</mat-card-content>
    </mat-card>
  </div>
</ng-template>